import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Lookup from '../../entities/lookup';
import Blackout from '../../entities/blackout';
import Discount from '../../entities/discount';
import Document from '../../entities/document';
import Expense from '../../entities/expense';
import Event from '../../entities/event';
import Identification from '../../entities/identification';
import Milestone from '../../entities/milestone';
import Participant from '../../entities/participant';
import TimeOff from '../../entities/timeOff';
export function deleteLookup(lookup: Lookup, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = lookup.id;}
const _work = workingSet();
store.getState().blackouts.getMappingFor('reason', lookup.id).filter(blackoutTemp => blackoutTemp.status !== 'D').forEach(blackoutTemp => {
const _blackout = ((_work.get('blackout:' + blackoutTemp.id) ?? blackoutTemp) as Blackout).clone();
_blackout.status = 'U';
_blackout.addedOn = newHRTimestamp();
_blackout.addedBy = getCurrentUserId();
_blackout.importSource = targetImportSource;
_blackout.importId = mergeId;
if (_blackout.reason === lookup.id) {
_blackout.reason = '';

}
_work.set('blackout:' + _blackout.id, _blackout);
store.dispatch(Actions.BlackoutActions.saveBlackoutQueue(_blackout));
});
store.getState().discounts.getMappingFor('reason', lookup.id).filter(discountTemp => discountTemp.status !== 'D').forEach(discountTemp => {
const _discount = ((_work.get('discount:' + discountTemp.id) ?? discountTemp) as Discount).clone();
_discount.status = 'U';
_discount.addedOn = newHRTimestamp();
_discount.addedBy = getCurrentUserId();
_discount.importSource = targetImportSource;
_discount.importId = mergeId;
if (_discount.reason === lookup.id) {
_discount.reason = '';

}
_work.set('discount:' + _discount.id, _discount);
store.dispatch(Actions.DiscountActions.saveDiscountQueue(_discount));
});
store.getState().documents.getMappingFor('tags', lookup.id).filter(documentTemp => documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.status = 'U';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_document.tags = _document.tags?.filter(id => id !== lookup.id) || [];

_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
});
store.getState().expenses.getMappingFor('expenseType', lookup.id).filter(expenseTemp => expenseTemp.status !== 'D').forEach(expenseTemp => {
const _expense = ((_work.get('expense:' + expenseTemp.id) ?? expenseTemp) as Expense).clone();
_expense.status = 'U';
_expense.addedOn = newHRTimestamp();
_expense.addedBy = getCurrentUserId();
_expense.importSource = targetImportSource;
_expense.importId = mergeId;
if (_expense.expenseType === lookup.id) {
_expense.expenseType = '';

}
_work.set('expense:' + _expense.id, _expense);
store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
});
store.getState().events.getMappingFor('category', lookup.id).filter(eventTemp => eventTemp.status !== 'D').forEach(eventTemp => {
const _event = ((_work.get('event:' + eventTemp.id) ?? eventTemp) as Event).clone();
_event.status = 'U';
_event.addedOn = newHRTimestamp();
_event.addedBy = getCurrentUserId();
_event.importSource = targetImportSource;
_event.importId = mergeId;
if (_event.category === lookup.id) {
_event.category = '';

}
_work.set('event:' + _event.id, _event);
store.dispatch(Actions.EventActions.saveEventQueue(_event));
});
store.getState().identifications.getMappingFor('methodType', lookup.id).filter(identificationTemp => identificationTemp.status !== 'D').forEach(identificationTemp => {
const _identification = ((_work.get('identification:' + identificationTemp.id) ?? identificationTemp) as Identification).clone();
_identification.status = 'U';
_identification.addedOn = newHRTimestamp();
_identification.addedBy = getCurrentUserId();
_identification.importSource = targetImportSource;
_identification.importId = mergeId;
if (_identification.methodType === lookup.id) {
_identification.methodType = '';

}
_work.set('identification:' + _identification.id, _identification);
store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
});
store.getState().milestones.getMappingFor('reasons', lookup.id).filter(milestoneTemp => milestoneTemp.status !== 'D').forEach(milestoneTemp => {
const _milestone = ((_work.get('milestone:' + milestoneTemp.id) ?? milestoneTemp) as Milestone).clone();
_milestone.status = 'U';
_milestone.addedOn = newHRTimestamp();
_milestone.addedBy = getCurrentUserId();
_milestone.importSource = targetImportSource;
_milestone.importId = mergeId;
_milestone.reasons = _milestone.reasons?.filter(id => id !== lookup.id) || [];

_work.set('milestone:' + _milestone.id, _milestone);
store.dispatch(Actions.MilestoneActions.saveMilestoneQueue(_milestone));
});
store.getState().participants.getMappingFor('relationships', lookup.id).filter(participantTemp => participantTemp.status !== 'D').forEach(participantTemp => {
const _participant = ((_work.get('participant:' + participantTemp.id) ?? participantTemp) as Participant).clone();
_participant.status = 'U';
_participant.addedOn = newHRTimestamp();
_participant.addedBy = getCurrentUserId();
_participant.importSource = targetImportSource;
_participant.importId = mergeId;
_participant.relationships = _participant.relationships?.filter(id => id !== lookup.id) || [];

_work.set('participant:' + _participant.id, _participant);
store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
});
store.getState().timeOffs.getMappingFor('reason', lookup.id).filter(timeOffTemp => timeOffTemp.status !== 'D').forEach(timeOffTemp => {
const _timeOff = ((_work.get('timeOff:' + timeOffTemp.id) ?? timeOffTemp) as TimeOff).clone();
_timeOff.status = 'U';
_timeOff.addedOn = newHRTimestamp();
_timeOff.addedBy = getCurrentUserId();
_timeOff.importSource = targetImportSource;
_timeOff.importId = mergeId;
if (_timeOff.reason === lookup.id) {
_timeOff.reason = '';

}
_work.set('timeOff:' + _timeOff.id, _timeOff);
store.dispatch(Actions.TimeOffActions.saveTimeOffQueue(_timeOff));
});



lookup.status = 'D';
lookup.addedOn = newHRTimestamp();
lookup.addedBy = getCurrentUserId();
lookup.importSource = targetImportSource;
lookup.importId = mergeId;
store.dispatch(Actions.LookupActions.removeLookupQueue(lookup));
}
export function replaceLookup(lookup: Lookup, replaceWith: Lookup, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = lookup.id;}
const _work = workingSet();
store.getState().blackouts.getMappingFor('reason', lookup.id).filter(blackoutTemp => blackoutTemp.status !== 'D').forEach(blackoutTemp => {
const _blackout = ((_work.get('blackout:' + blackoutTemp.id) ?? blackoutTemp) as Blackout).clone();
_blackout.status = 'U';
_blackout.addedOn = newHRTimestamp();
_blackout.addedBy = getCurrentUserId();
_blackout.importSource = targetImportSource;
_blackout.importId = mergeId;
if (_blackout.reason === lookup.id) {
_blackout.reason = replaceWith.id;

}
_work.set('blackout:' + _blackout.id, _blackout);
store.dispatch(Actions.BlackoutActions.saveBlackoutQueue(_blackout));
});
store.getState().discounts.getMappingFor('reason', lookup.id).filter(discountTemp => discountTemp.status !== 'D').forEach(discountTemp => {
const _discount = ((_work.get('discount:' + discountTemp.id) ?? discountTemp) as Discount).clone();
_discount.status = 'U';
_discount.addedOn = newHRTimestamp();
_discount.addedBy = getCurrentUserId();
_discount.importSource = targetImportSource;
_discount.importId = mergeId;
if (_discount.reason === lookup.id) {
_discount.reason = replaceWith.id;

}
_work.set('discount:' + _discount.id, _discount);
store.dispatch(Actions.DiscountActions.saveDiscountQueue(_discount));
});
store.getState().documents.getMappingFor('tags', lookup.id).filter(documentTemp => documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.status = 'U';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_document.tags = _document.tags?.map(id => (id === lookup.id) ? replaceWith.id : id) || [];

_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
});
store.getState().expenses.getMappingFor('expenseType', lookup.id).filter(expenseTemp => expenseTemp.status !== 'D').forEach(expenseTemp => {
const _expense = ((_work.get('expense:' + expenseTemp.id) ?? expenseTemp) as Expense).clone();
_expense.status = 'U';
_expense.addedOn = newHRTimestamp();
_expense.addedBy = getCurrentUserId();
_expense.importSource = targetImportSource;
_expense.importId = mergeId;
if (_expense.expenseType === lookup.id) {
_expense.expenseType = replaceWith.id;

}
_work.set('expense:' + _expense.id, _expense);
store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
});
store.getState().events.getMappingFor('category', lookup.id).filter(eventTemp => eventTemp.status !== 'D').forEach(eventTemp => {
const _event = ((_work.get('event:' + eventTemp.id) ?? eventTemp) as Event).clone();
_event.status = 'U';
_event.addedOn = newHRTimestamp();
_event.addedBy = getCurrentUserId();
_event.importSource = targetImportSource;
_event.importId = mergeId;
if (_event.category === lookup.id) {
_event.category = replaceWith.id;

}
_work.set('event:' + _event.id, _event);
store.dispatch(Actions.EventActions.saveEventQueue(_event));
});
store.getState().identifications.getMappingFor('methodType', lookup.id).filter(identificationTemp => identificationTemp.status !== 'D').forEach(identificationTemp => {
const _identification = ((_work.get('identification:' + identificationTemp.id) ?? identificationTemp) as Identification).clone();
_identification.status = 'U';
_identification.addedOn = newHRTimestamp();
_identification.addedBy = getCurrentUserId();
_identification.importSource = targetImportSource;
_identification.importId = mergeId;
if (_identification.methodType === lookup.id) {
_identification.methodType = replaceWith.id;

}
_work.set('identification:' + _identification.id, _identification);
store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
});
store.getState().milestones.getMappingFor('reasons', lookup.id).filter(milestoneTemp => milestoneTemp.status !== 'D').forEach(milestoneTemp => {
const _milestone = ((_work.get('milestone:' + milestoneTemp.id) ?? milestoneTemp) as Milestone).clone();
_milestone.status = 'U';
_milestone.addedOn = newHRTimestamp();
_milestone.addedBy = getCurrentUserId();
_milestone.importSource = targetImportSource;
_milestone.importId = mergeId;
_milestone.reasons = _milestone.reasons?.map(id => (id === lookup.id) ? replaceWith.id : id) || [];

_work.set('milestone:' + _milestone.id, _milestone);
store.dispatch(Actions.MilestoneActions.saveMilestoneQueue(_milestone));
});
store.getState().participants.getMappingFor('relationships', lookup.id).filter(participantTemp => participantTemp.status !== 'D').forEach(participantTemp => {
const _participant = ((_work.get('participant:' + participantTemp.id) ?? participantTemp) as Participant).clone();
_participant.status = 'U';
_participant.addedOn = newHRTimestamp();
_participant.addedBy = getCurrentUserId();
_participant.importSource = targetImportSource;
_participant.importId = mergeId;
_participant.relationships = _participant.relationships?.map(id => (id === lookup.id) ? replaceWith.id : id) || [];

_work.set('participant:' + _participant.id, _participant);
store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
});
store.getState().timeOffs.getMappingFor('reason', lookup.id).filter(timeOffTemp => timeOffTemp.status !== 'D').forEach(timeOffTemp => {
const _timeOff = ((_work.get('timeOff:' + timeOffTemp.id) ?? timeOffTemp) as TimeOff).clone();
_timeOff.status = 'U';
_timeOff.addedOn = newHRTimestamp();
_timeOff.addedBy = getCurrentUserId();
_timeOff.importSource = targetImportSource;
_timeOff.importId = mergeId;
if (_timeOff.reason === lookup.id) {
_timeOff.reason = replaceWith.id;

}
_work.set('timeOff:' + _timeOff.id, _timeOff);
store.dispatch(Actions.TimeOffActions.saveTimeOffQueue(_timeOff));
});



return lookup;
}
export function deleteImpactLookup(lookup: Lookup) {
const impacts: string[] = [];
const state = store.getState();
const blackoutReasonImpact = state.blackouts.getMappingFor('reason', lookup.id).filter(blackout => blackout.status !== 'D');
blackoutReasonImpact.forEach(() => impacts.push('blackouts*'));
const discountReasonImpact = state.discounts.getMappingFor('reason', lookup.id).filter(discount => discount.status !== 'D');
discountReasonImpact.forEach(() => impacts.push('discounts*'));
const documentTagsImpact = state.documents.getMappingFor('tags', lookup.id).filter(document => document.status !== 'D');
documentTagsImpact.forEach(() => impacts.push('documents'));
const expenseExpenseTypeImpact = state.expenses.getMappingFor('expenseType', lookup.id).filter(expense => expense.status !== 'D');
expenseExpenseTypeImpact.forEach(() => impacts.push('expenses*'));
const eventCategoryImpact = state.events.getMappingFor('category', lookup.id).filter(event => event.status !== 'D');
eventCategoryImpact.forEach(() => impacts.push('events*'));
const identificationMethodTypeImpact = state.identifications.getMappingFor('methodType', lookup.id).filter(identification => identification.status !== 'D');
identificationMethodTypeImpact.forEach(() => impacts.push('identifications*'));
const milestoneReasonsImpact = state.milestones.getMappingFor('reasons', lookup.id).filter(milestone => milestone.status !== 'D');
milestoneReasonsImpact.forEach(() => impacts.push('milestones'));
const participantRelationshipsImpact = state.participants.getMappingFor('relationships', lookup.id).filter(participant => participant.status !== 'D');
participantRelationshipsImpact.forEach(() => impacts.push('participants*'));
const timeOffReasonImpact = state.timeOffs.getMappingFor('reason', lookup.id).filter(timeOff => timeOff.status !== 'D');
timeOffReasonImpact.forEach(() => impacts.push('timeOffs*'));



return util.countDistinct(impacts);
}
